import React from "react";

const ProjectPage = () => {
  const videoId = "9C0iaJlsgEU";

  const credits = [
    { role: "Director / Cinematographer / Editor", name: "Sylvester P. Lukasiewicz, SPL Films LLC" },
    { role: "Sound Mixer", name: "Robert Kahn, Mixology Post LLC" },
    { role: "Color Correction & Grading", name: "Luis Otero, CSI, Digital Emulsion LLC" },
  ];

  return (
    // Removed the white background. 
    // Added 'text-white' so it inherits your global App.tsx dark gradient beautifully.
    <div className="max-w-5xl mx-auto px-8 py-12 md:py-16 text-white">
      
      {/* Header & Video Section - Two Columns on Desktop */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-8">
        
        {/* Left Column: Title & Metadata */}
        <div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
            Back to One - Return to Ground Zero
          </h1>
          <div className="font-semibold text-sm leading-snug tracking-wide text-gray-300">
            <p>Documentary Short</p>
            <p>United States | 26 minutes</p>
            <p>English | English subtitles</p>
          </div>
        </div>

        {/* Right Column: Video Embed */}
        <div className="relative pb-[56.25%] h-0 shadow-2xl rounded overflow-hidden border border-gray-700 bg-black">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title="Back to One"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* Top Divider - Changed to gray-500 to be visible on dark background */}
      <hr className="border-gray-500 border-t my-10" />

      {/* Synopsis */}
      <section className="space-y-6 text-lg text-gray-200">
        <p className="font-bold text-xl leading-relaxed text-white">
          An intimate documentary following a former Windows on the World employee and 9/11 survivor as he returns to the rebuilt World Trade Center site for the first time in 24 years, honoring lost colleagues and reflecting on memory, resilience, and healing. 
        </p>
        <p>
          In this moving documentary, former Windows on the World banquet captain and manager Stephen Lindsey reflects on the events of September 11, 2001, and the lasting impact of that day on his life and community. Through personal memories and a return to the rebuilt World Trade Center site, Stephen recounts witnessing the attacks, coping with the loss of colleagues and friends, and finding ways to honor those who never came home.
        </p>
        <p>
          As he walks through the 9/11 Memorial, The Oculus, and the Winter Garden, Stephen shares stories of camaraderie, everyday joys, and small acts of kindness that defined the close-knit community he once knew. Juxtaposing the beauty of the reconstructed site with the profound absence left behind, the film explores themes of grief, memory, resilience, and healing. Both a deeply personal elegy and a tribute to collective remembrance, it celebrates the enduring human spirit in the face of unimaginable loss.
        </p>
      </section>

      {/* Bottom Divider */}
      <hr className="border-gray-500 border-t my-10" />

      {/* Credits */}
      <section>
        <h2 className="text-2xl font-extrabold tracking-widest mb-8 text-white">CREDITS</h2>
        <div className="space-y-6">
          {credits.map((credit, index) => (
            <div key={index}>
              <h3 className="font-bold text-lg text-white">{credit.role}</h3>
              <p className="text-md text-gray-300">{credit.name}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export { ProjectPage };